import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import BlogPostCard from '../atoms/blog-post-card';
import ArchiveCardSkeleton from '../atoms/archive-card-skeleton';

const ArchiveResults = ({
  children,
  items,
  renderItems,
  renderCard,
  renderLoadingCard,
  getCardProps,
  isList,
  isLoading,
}) => {
  return (
    <div
      className={classNames('archive-results', {
        'archive-results--list': isList,
      })}
    >
      {!isLoading &&
        renderItems &&
        items.map((item, index) => {
          const {
            id = index,
            title,
            slug,
            date,
            excerpt,
            content,
            imageObj,
            categoryName,
            categorySlug,
          } = getCardProps(item);

          return (
            <div className="archive-results__item" key={id}>
              {renderCard && renderCard(item)}
              {!renderCard && (
                <BlogPostCard
                  title={title}
                  slug={slug}
                  date={date}
                  excerpt={excerpt}
                  content={content}
                  image={imageObj}
                  categoryName={categoryName}
                  categorySlug={categorySlug}
                  isListing={isList}
                />
              )}
            </div>
          );
        })}
      {isLoading && (
        <Fragment>
          {renderLoadingCard && renderLoadingCard()}
          {!renderLoadingCard &&
            [1, 2, 3, 4, 5].map((item, index) => {
              return (
                <div className="archive-results__item" key={index}>
                  <ArchiveCardSkeleton
                    hasCategory={false}
                    hasDate={false}
                    isListing={isList}
                    content="<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ultricies aliquet eros, id elementum eros pharetra at. Quisque vitae tempor felis. Maecenas congue aliquet massa, id ultricies lectus tristique et.</p>"
                  />
                </div>
              );
            })}
        </Fragment>
      )}
      {children}
    </div>
  );
};

ArchiveResults.propTypes = {
  isList: PropTypes.bool,
  renderItems: PropTypes.bool,
  getCardProps: PropTypes.func,
  renderCard: PropTypes.func,
};

ArchiveResults.defaultProps = {
  isList: false,
  renderItems: true,
  getCardProps: () => {
    return {
      id: null,
      title: '',
      slug: '',
      date: null,
      categoryName: null,
      categorySlug: null,
      imageObj: undefined,
      excerpt: '',
      content: '',
    };
  },
  renderCard: undefined,
};

export default ArchiveResults;
